import { render, staticRenderFns } from "./ready.vue?vue&type=template&id=5dce335f&scoped=true"
import script from "./ready.vue?vue&type=script&lang=js"
export * from "./ready.vue?vue&type=script&lang=js"
import style0 from "./ready.vue?vue&type=style&index=0&id=5dce335f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce335f",
  null
  
)

export default component.exports